import {useContext} from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
//import Dashboard from "./../components/Sales/Dashboard";

const AuthenticationChecker = ({children, allowedRoles}) =>{

    const {user, loading} = useContext(AuthContext);

    //console.log('I am in authchecker');

    if(loading)
    {
        return <p>Checking auth...</p>;
    }

    if(!user)
    {
        return <Navigate to="/sign-in" />;
    }

    if(allowedRoles && !allowedRoles.includes(user.role_id))
    {
        return <Navigate to="/sign-in" />;
    }

    return children;
    
}

export default AuthenticationChecker;